
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Rooms', path: '/rooms' },
    { name: 'The Pub', path: '/pub' },
    { name: 'Menu', path: '/menu' },
    { name: 'Events', path: '/events' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-ov-cream-50 shadow-lg' : 'bg-ov-cream-50/95 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <Link to="/" className="flex items-center group flex-shrink-0">
            <h1 className="sr-only">The Ocean View Inn & Sports Pub</h1>
            <img 
              src="https://static.readdy.ai/image/a0544820e0625081891e0a711cac5596/5337f555661671eb499c5bbdb40f9c20.png" 
              alt="Dunn's O.V. OceanView Inn & Sports Pub Logo" 
              className="h-12 sm:h-14 lg:h-16 w-auto object-contain transform group-hover:scale-105 transition-transform duration-300"
              loading="eager"
            />
          </Link>

          <nav className="hidden lg:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  location.pathname === link.path
                    ? 'bg-ov-teal-600 text-white'
                    : 'text-ov-sand-800 hover:bg-ov-sand-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:flex items-center space-x-3">
            <a
              href="tel:+13056648052"
              className="flex items-center space-x-2 px-4 py-2 text-ov-sand-700 hover:text-ov-teal-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line text-lg"></i>
              <span className="text-sm font-medium">(305) 664-8052</span>
            </a>
            <a
              href="https://hotels.cloudbeds.com/en/reservation/KsGpNF"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-2.5 bg-gradient-to-r from-ov-teal-600 to-ov-blue-500 text-white rounded-lg font-medium hover:shadow-lg transform hover:scale-105 transition-all duration-200 whitespace-nowrap"
            >
              Book Now
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-ov-sand-100 transition-colors flex-shrink-0"
            aria-label="Toggle menu"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-ov-sand-700`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden bg-ov-cream-50 border-t border-ov-sand-200 shadow-lg">
          <nav className="max-w-7xl mx-auto px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.path
                    ? 'bg-ov-teal-600 text-white'
                    : 'text-ov-sand-700 hover:bg-ov-sand-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <div className="pt-4 space-y-2">
              <a
                href="tel:+13056648052"
                className="flex items-center justify-center space-x-2 px-4 py-3 bg-ov-sand-100 rounded-lg text-ov-sand-700 hover:bg-ov-sand-200 transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line text-lg"></i>
                <span className="text-sm font-medium">(305) 664-8052</span>
              </a>
              <a
                href="https://hotels.cloudbeds.com/en/reservation/KsGpNF"
                target="_blank"
                rel="noopener noreferrer"
                className="block text-center px-6 py-3 bg-gradient-to-r from-ov-teal-600 to-ov-blue-500 text-white rounded-lg font-medium hover:shadow-lg transition-all whitespace-nowrap"
              >
                Book Now
              </a>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
